<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        md="4"
        class="d-flex justify-center align-center d-md-block"
      >
        <a
          :href="$router.resolve({
            name: 'UploadSlipByOrderIdWithPayment',
            params: { orderId, payment: 'qrCode' }
          }).href"
          class="link"
        >
          <v-card
            outlined
            height="310"
            width="310"
            class="pa-4 rounded-xl"
          >
            <div class="fill-height d-flex flex-column justify-center align-center">
              <img
                class=""
                src="/svg/payment/qr-code.svg"
                alt="QR Code"
                width="60">

              <div class="_fs-24 mt-8">
                QR Code
              </div>
            </div>
          </v-card>
        </a>
      </v-col>

      <v-col
        cols="12"
        md="4"
        class="d-flex justify-center align-center d-md-block"
      >
        <div>
          <a
            :href="$router.resolve({
              name: 'UploadSlipByOrderIdWithPayment',
              params: { orderId, payment: 'transfer' }
            }).href"
            class="link"
          >
            <v-card
              outlined
              height="310"
              width="310"
              class="pa-4 d-flex flex-column justify-center align-center rounded-xl"
            >
              <img
                class="mb-4 mb-sm-0"
                src="/svg/bank/kbank.svg"
                alt="KBank Logo"
                width="100">
              <div class="d-flex flex-column pt-4 align-center">
                <div>
                  โอนเข้าบัญชีธนาคาร <span class="font-weight-bold">กสิกรไทย</span>
                </div>
                <div class="pt-1">
                  สาขา <span class="font-weight-bold">เซ็นทรัลพระราม 9</span>
                </div>
                <div class="pt-1">
                  ชื่อบัญชี <span class="font-weight-bold">บจก. เซลสุกิ</span>
                </div>
                <div class="pt-1">
                  เลขที่บัญชี <span class="font-weight-bold">055-1-27809-3</span>
                </div>
              </div>

              <v-btn
                class="mt-4"
                color="primary"
                rounded
                min-width="200"
                elevation="0"
              >
                แจ้งหลักฐานชำระเงิน
              </v-btn>
            </v-card>
          </a>

          <div class="mt-3 grey--text text-center">
            (บัญชีสำหรับชำระค่าบริการ<br>LINE Official Account เท่านั้น)
          </div>
        </div>
      </v-col>

      <v-col
        cols="12"
        md="4"
        class="d-flex justify-center align-center d-md-block"
      >
        <a
          :href="$router.resolve({
            name: 'UploadSlipByOrderIdWithPayment',
            params: { orderId, payment: 'byCreditCard' }
          }).href"
          class="link"
        >
          <v-card
            outlined
            height="310"
            width="310"
            class="pa-4 d-flex flex-column justify-center align-center rounded-xl"
          >
            <img
              class="mb-4 mb-sm-0"
              src="/svg/payment/credit-card.svg"
              alt="credit card"
              width="120">

            <div class="_fs-24 mt-8">
              บัตรเครดิต/เดบิต
            </div>
          </v-card>
        </a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'BasePaymentMethodCard',
  props: {
    orderId: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.link {
  text-decoration: none;
}
</style>
